export const FRONTEND_SUPPORT_SUFFIX = 'Contact System Administrator';
const FRONTEND_ERROR_LOG_ENDPOINT = '/api/frontend-error';
const FRONTEND_ERROR_LOG_DEDUPE_WINDOW_MS = 5000;
const recentFrontendErrorLogMap = new Map();

export const extractErrorCodePrefix = (message) => {
  if (typeof message !== 'string') {
    return null;
  }

  const trimmed = message.trim();
  if (!trimmed) {
    return null;
  }

  const match = trimmed.match(/^([A-Za-z0-9_-]+)\s*-\s+/);
  return match ? match[1] : null;
};

const canReportFrontendError = () =>
  typeof window !== 'undefined' &&
  typeof window.fetch === 'function';

const cleanupRecentFrontendLogMap = (nowMs) => {
  recentFrontendErrorLogMap.forEach((loggedAtMs, signature) => {
    if (nowMs - loggedAtMs > FRONTEND_ERROR_LOG_DEDUPE_WINDOW_MS) {
      recentFrontendErrorLogMap.delete(signature);
    }
  });
};

const reportFrontendSupportError = ({ supportMessage, pageInfo, sourceMessage }) => {
  if (!canReportFrontendError()) {
    return;
  }

  const nowMs = Date.now();
  const normalizedSupportMessage = typeof supportMessage === 'string' ? supportMessage.trim() : '';
  if (!normalizedSupportMessage) {
    return;
  }

  const normalizedPageInfo = typeof pageInfo === 'string' ? pageInfo.trim() : '';
  const normalizedSourceMessage = typeof sourceMessage === 'string' ? sourceMessage.trim() : '';
  const logSignature = `${normalizedSupportMessage}|${normalizedSourceMessage}`;

  cleanupRecentFrontendLogMap(nowMs);

  const lastLoggedAtMs = recentFrontendErrorLogMap.get(logSignature);
  if (lastLoggedAtMs && nowMs - lastLoggedAtMs < FRONTEND_ERROR_LOG_DEDUPE_WINDOW_MS) {
    return;
  }

  recentFrontendErrorLogMap.set(logSignature, nowMs);

  const payload = {
    support_message: normalizedSupportMessage,
    page_info: normalizedPageInfo,
    source_message: normalizedSourceMessage,
    client_time: new Date(nowMs).toISOString(),
  };

  window
    .fetch(FRONTEND_ERROR_LOG_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      keepalive: true,
      body: JSON.stringify(payload),
    })
    .catch(() => {});
};

export const formatFrontendSupportError = ({ errorCode, pageInfo, sourceMessage }) => {
  const backendCode = extractErrorCodePrefix(sourceMessage);
  const resolvedCode = backendCode || errorCode;
  const supportMessage = `${resolvedCode} - ${pageInfo} - ${FRONTEND_SUPPORT_SUFFIX}`;

  reportFrontendSupportError({
    supportMessage,
    pageInfo,
    sourceMessage,
  });

  return supportMessage;
};
